import React from 'react';
import { CheckIcon } from 'lucide-react';
import { outcomes } from '../data/landing';
export function Outcomes() {
  return <section className="w-full bg-sand" data-id="element-141" data-mp="1h8exsfxikbm1">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-20" data-id="element-142" data-mp="1hbklpruep7g6">
        <h2 className="max-w-2xl font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-143" data-mp="1m9cgctmfr7o2">
          ¿Qué vas a lograr con este método?
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-[1fr_1fr_0.9fr]" data-id="element-144" data-mp="tknm9ejss2lt">
          <ul className="grid gap-4 md:col-span-2 md:grid-cols-2 lg:col-span-2" data-id="element-145" data-mp="yiyvpo66kb3i">
            {outcomes.map(item => <li key={item.title} className="flex h-full flex-col rounded-xl bg-white p-6 shadow-card" data-id="element-146" data-mp="13i1ooa8vyqv4">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-olive text-white" data-id="element-147" data-mp="18auwj6znifbf">
                  <CheckIcon aria-hidden="true" className="h-4 w-4" strokeWidth={3} data-id="element-148" data-mp="fsqzlq0wekwt" />
                </span>
                <h3 className="mt-4 font-sans text-lg font-bold text-ink" data-id="element-149" data-mp="32x8aasl4jryv">{item.title}</h3>
                <p className="mt-2 font-sans text-[15px] leading-relaxed text-muted" data-id="element-150" data-mp="2xyeugtid7ovj">
                  {item.body}
                </p>
              </li>)}
          </ul>

          <img src="https://cdn.magicpatterns.com/patterns/generated-images/a4c0fc24-8b8c-46e2-b99a-511620870637.jpg" alt="Dos viandas escolares con milanesa, tomates cherry, cubos de queso y fruta" className="hidden h-full w-full rounded-xl object-cover shadow-card lg:block" data-id="element-151" data-mp="2t5loy3f2ocie" />
        </div>
      </div>
    </section>;
}